<template>
  <div>
		<div class="navbar">
			<b-button to="/" :data="data" :convertionsData="convertionsData" :applicationsData="applicationsData" :vCleanCodes="vCleanCodes" :competitorCodes="competitorCodes" variant="outline-light">
				NOVA PESQUISA
			</b-button>
		</div>
		<b-container>
			<b-row v-if="selected.automakerLogo">
				<b-col cols="12">
					<b-img
						width="75"
						height="75"
						rounded="circle"
						:src="selected.automakerLogo" />
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">MARCA:</span>
					<span>{{ brand }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">MODELO:</span>
					<span>{{ model }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<span class="title">ANO:</span>
					<span>{{ displayYear }}</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" :md="selected.back.carren || selected.back.slim || selected.back.iron ? 6 : 12" 
					v-if="selected.specific && (selected.specific.pair || selected.specific.driver || selected.specific.passenger || selected.front.hybridDriver || selected.front.hybridPassenger || selected.front.flexDriver || selected.front.flexPassenger || selected.front.ironDriver || selected.front.ironPassenger)"
					>
					<b-card
						no-body
						:img-src="selected.frontPhoto">

						<div class="column-header" v-if="selected.specific.pair || selected.specific.driver || selected.specific.passenger">
							<span class="column-header-title">PALHETA DIANTEIRA ESPECÍFICA</span>
							<span v-if="selected.specific.pair">PAR: {{ selected.specific.pair }}</span>
							<span v-if="selected.specific.driver">MOTORISTA: {{selected.specific.driver }}</span>
							<span v-if="selected.specific.passenger">PASSAGEIRO: {{ selected.specific.passenger }}</span>
						</div>

						<div class="column-header" v-else>
							<span class="column-header-title">PALHETA DIANTEIRA</span>
							<span v-if="selected.front.hybridDriver">HÍBRIDA MOTORISTA: {{ selected.front.hybridDriver }}</span>
							<span v-if="selected.front.hybridPassenger">HÍBRIDA PASSAGEIRO: {{ selected.front.hybridPassenger }}</span>
							<span v-if="selected.front.flexDriver" style="margin-top:10px">FLEX MOTORISTA: {{ selected.front.flexDriver }}</span>
							<span v-if="selected.front.flexPassenger">FLEX PASSAGEIRO: {{ selected.front.flexPassenger }}</span>
							<span v-if="selected.front.ironDriver" style="margin-top:10px">FERRO MOTORISTA: {{ selected.front.ironDriver }}</span>
							<span v-if="selected.front.ironPassenger">FERRO PASSAGEIRO: {{ selected.front.ironPassenger }}</span>
						</div>

						<div v-if="selected.frontDescription" class="description">
							<span>
								{{ selected.frontDescription }}
							</span>
						</div>

						<b-embed
							type="iframe"
							v-if="selected.frontVideo"
							:src="selected.frontVideo"
							allowfullscreen />
					</b-card>
				</b-col>
				<b-col cols="12" 
					:md="selected.back.carren || selected.back.slim || selected.back.iron ? 6 : 12"
					v-if="selected.back.carren || selected.back.slim || selected.back.iron">
					<b-card
						no-body
						:img-src="selected.backPhoto">

						<div class="column-header">
							<span class="column-header-title">PALHETA TRASEIRA</span>
							<span v-if="selected.back.carren">CARENADA: {{ selected.back.carren }}</span>
							<span v-if="selected.back.slim">SLIM: {{ selected.back.slim }}</span>
							<span v-if="selected.back.iron">FERRO: {{ selected.back.iron }}</span>
						</div>
						<div v-if="selected.backDescription" class="description">
							<span>
								{{ selected.backDescription }}
							</span>
						</div>

						<b-embed
							type="iframe"
							v-if="selected.backVideo"
							:src="selected.backVideo"
							allowfullscreen />
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<div id="modal" class="modal">
			<span class="modal-close">&times;</span>
			<img class="modal-content" id="modal-image">
		</div>
  </div>
</template>

<script>
export default {
	name: 'ProductDetail',
	props: {
		brand: String,
		model: String,
		year: String,
		data: Array,
		convertionsData: Array,
		applicationsData: Array,
		vCleanCodes: Array,
		competitorCodes: Array
	},

	data() {
		return {
			imgProps: {
				blank: true, 
				blankColor: '#777', 
				width: 50, 
				height: 50
			},
			displayFront: '',
			displayYear: '',
			selected: {}
		};
	},

	methods: {
		init: function() {
			this.displayYear = this.year;

			const filteredBrand = this.data.find(item => item.brand === this.brand);
			const filteredModel = filteredBrand.models.find(item => item.model === this.model);
			const [ from, to ] = this.year.split('-');
			
			this.selected = filteredModel.items.find(item => {
				return item.from === from && item.to === to;
			});

			this.displayYear = `DE: ${this.selected.from} ATÉ: ${this.selected.to}`;
		}
	},
	
	created() {
		this.init();
	}
};
</script>

<style scoped>
	input[type='text'] {
		margin-bottom: 15px;
	}
	.navbar {
		margin-bottom: 15px;
		background-color: #e9ecef;
		border: 1px solid #dfe4e8;
		border-radius: calc(0.25rem - 1px);
	}
	.title {
		font-weight: bold;
		margin-right: 5px;
	}
	.description {
		padding: 15px 10px;
	}
	.card {
		align-items: center;
		margin-top: 30px;
		padding: 10px;
	}
	.card-img {
		cursor: pointer;
		transition: 0.3s;
		width: 75%;
	}
	.card-img:hover {
		opacity: 0.8;
	}
	.column-header {
		width: 100%;
		font-weight: bold;
		padding: 5px 0;
		background-color: #e9ecef;
		border: 1px solid #dfe4e8;
		border-radius: calc(0.25rem - 1px);
		margin-bottom: 10px;
	}
	.column-header > span {
		display: block;
	}
	.column-header-title {
		padding-bottom: 10px;
		font-weight: bold;
	}
</style> -->
